import React, { useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT --------------------------
import { OverlayPanel } from "primereact/overlaypanel";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";

// ------------------ COMPONENTES DE BASE --------------------------------
import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";

// ------------------ COMPONENTES DE NECESARIOS --------------------------
import UbicacionesCrudModal from "../../../Ubicaciones/UbicacionesCrudModal";

const OverlayUbicacionPacas = ({
  rowData,
  rowKey,
  estantes,
  filas,
  posiciones,
  listadoDetalles,
  disabled,
  onChange,
  onToast,
  onReloadUbicaciones,
  api,
}) => {
  const op = useRef(null);

  const [estanteSeleccionado, setEstanteSeleccionado] = useState(null);
  const [filaSeleccionada, setFilaSeleccionada] = useState(null);
  const [showUbicacionesCrud, setShowUbicacionesCrud] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [estantesLocal, setEstantesLocal] = useState(estantes || []);
  const [filasLocal, setFilasLocal] = useState(filas || []);
  const [posicionesLocal, setPosicionesLocal] = useState(posiciones || []);

  const refrescarUbicaciones = async () => {
    const nuevasUbicaciones = await onReloadUbicaciones?.();

    if (nuevasUbicaciones) {
      setEstantesLocal(nuevasUbicaciones.estantes || []);
      setFilasLocal(nuevasUbicaciones.filas || []);
      setPosicionesLocal(nuevasUbicaciones.posiciones || []);
    }

    setEstanteSeleccionado(null);
    setFilaSeleccionada(null);
    setRefreshKey((prev) => prev + 1);

    onToast?.("success", "Actualizado", "Ubicaciones actualizadas correctamente.");
  };

  const posicionesUsadas = (listadoDetalles || [])
  .filter((item) => {
    const itemKey = item.IdPaca > 0 ? item.IdPaca : item.GinBale;

    return itemKey !== rowKey && item.IdBandeja;
  })
  .map((item) => Number(item.IdBandeja));

  const filasDelEstante = filasLocal.filter(
    (fila) => fila.IdEstante === estanteSeleccionado?.IdEstante
  );

  const filasFiltradas = filasDelEstante;

  const posicionesDeFila = posicionesLocal.filter(
    (pos) => pos.IdPosicion === filaSeleccionada?.IdPosicion
  );

  const posicionesFiltradas = posicionesDeFila.filter(
    (pos) => !posicionesUsadas.includes(Number(pos.IdBandeja))
  );

  // Tabla estante para mostrar solo el estante seleccionado
  const tableEstantes = {
    Data: estantesLocal,
    hideFooter: true,
    Columns: [
      {
        field: "NombreBodega",
        header: "Bodega",
        flex: 1,
      },
      {
        field: "NombreEstante",
        header: "Nombre Estante",
        flex: 1,
      },
      {
        field: "NumeroEstante",
        header: "Numero Estante",
        flex: 1,
      },
    ],
    onCellClicked: (e) => {
      setEstanteSeleccionado(e.data);
      setFilaSeleccionada(null);

      const filasDeEseEstante = filasLocal.filter(
        (fila) => fila.IdEstante === e.data.IdEstante
      );

      if (filasDeEseEstante.length === 0) {
        onToast?.(
          "warn",
          "Sin filas",
          "El estante seleccionado no tiene filas creadas."
        );
      }
    },
  };

  const tableFilas = {
    Data: filasFiltradas,
    hideFooter: true,
    Columns: [
      {
        field: "NumeroPosicion",
        header: "Fila",
        flex: 1,
      },
      {
        field: "NombrePosicion",
        header: "Nombre Fila",
        flex: 1,
      },
    ],
    onCellClicked: (e) => {
      setFilaSeleccionada(e.data);

      const posicionesDeEsaFila = posicionesLocal.filter(
        (pos) => pos.IdPosicion === e.data.IdPosicion
      );

      if (posicionesDeEsaFila.length === 0) {
        onToast?.(
          "warn",
          "Sin posiciones",
          "La fila seleccionada no tiene posiciones o bandejas creadas."
        );
      }
    },
  };

  const tablePosiciones = {
    Data: posicionesFiltradas,
    hideFooter: true,
    Columns: [
      {
        field: "NumeroBandeja",
        header: "Posición",
        flex: 1,
      },
      {
        field: "NombreBandeja",
        header: "Nombre Posición",
        flex: 1,
      },
      {
        field: "Lado",
        header: "Lado",
        flex: 1,
      },
    ],
    onCellClicked: (e) => {
      onChange({
        rowData,
        rowKey,
        estante: estanteSeleccionado,
        fila: filaSeleccionada,
        posicion: e.data,
      });

      op.current.hide();

      if (api) {
        api.stopEditing();
      }
    },
  };

  useEffect(() => {
    setEstantesLocal(estantes || []);
    setFilasLocal(filas || []);
    setPosicionesLocal(posiciones || []);
  }, [estantes, filas, posiciones]);

  return (
  <div style={{ width: "100%" }}>
    <div className="p-inputgroup">
      <InputText
        value={
          rowData?.NumeroBandeja ||
          rowData?.NumeroPosicion ||
          rowData?.NumeroEstante ||
          ""
        }
        readOnly
        placeholder="Ubicación"
      />

      <Button
        icon="pi pi-chevron-down"
        style={{ padding: "0.5rem 0.3rem" }}
        type="button"
        onClick={(e) => op.current.toggle(e)}
      />
    </div>
    
    {/* Overlay Panel para el manejo de ubicaciones */}
    <OverlayPanel ref={op} showCloseIcon dismissable={false} style={{ zIndex: 9999 }}>
      <div style={{ width: 1100, height: 470, padding: 8 }}>
        
        <div className="d-flex justify-content-start mb-2">
          <Button
            icon="pi pi-cog"
            label="Administrar ubicaciones"
            onClick={() => {
              // op.current.hide();
              setShowUbicacionesCrud(true);
            }}
          />
          <Button
            icon="pi pi-refresh"
            className="ms-2"
            tooltip="Actualizar ubicaciones"
            tooltipOptions={{ position: "top" }}
            onClick={refrescarUbicaciones}
          />
        </div>

        <div className="d-flex gap-2" style={{ height: 420 }}>
          <div style={{ flex: 1, height: "100%", minWidth: 0 }}>
            <AgGrid key={`estantes-${refreshKey}`} table={tableEstantes} />
          </div>

          <div style={{ flex: 1, height: "100%", minWidth: 0 }}>
            <AgGrid key={`filas-${refreshKey}`} table={tableFilas} />
          </div>

          <div style={{ flex: 1, height: "100%", minWidth: 0 }}>
            <AgGrid key={`posiciones-${refreshKey}`} table={tablePosiciones} />
          </div>
        </div>

      </div>

    </OverlayPanel>

    {/* Modal para gestionar ubicaciones */}
    <UbicacionesCrudModal
      visible={showUbicacionesCrud}
      onHide={async () => {
        setShowUbicacionesCrud(false);
        await refrescarUbicaciones();
      }}
    />
  </div>
  );
};

export default OverlayUbicacionPacas;